import { LiveAnnouncer } from '@angular/cdk/a11y';
import { AfterViewInit, Component, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { timer } from 'rxjs';

import { LoginAudit } from '../model/login-audit';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { AccountService } from '../service/account.service';
import { LoginAuditRequest } from '../model/login-audit-request-data-view';

import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { DatePipe, formatDate } from '@angular/common';
import { Region } from 'src/app/model/region.model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

const sortingDataAccessor = (item: LoginAudit, property: string) => {
    switch (property) {
        case 'LOGINTIME':
            return new Date(item.LOGIN_TIME).getTime();
        case 'LOGOUTTIME':
            return new Date(item.LOGOUT_TIME ? item.LOGOUT_TIME : new Date()).getTime();
        case 'USERNAME':
            return item.LOGIN_DETAILS.USER_ID;
        case 'NAME':
            return item.LOGIN_DETAILS.PERSON.FIRST_NAME!.toLocaleLowerCase() + item.LOGIN_DETAILS.PERSON.LAST_NAME!.toLocaleLowerCase();
        case 'REGION':
            return item.REGION.CODE;
        default:
            return item.ID;
    }
};

@Component({
    selector: 'app-login-audits',
    templateUrl: './login-audits.component.html',
    styleUrls: ['./login-audits.component.scss']
})
export class LoginAuditsComponent implements OnInit, AfterViewInit {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) searchPaginator: MatPaginator;

    resetField: boolean = false;
    lstSelectedRegion: Region[] = [];
    isLoadingResults: boolean = false;

    range = new UntypedFormGroup({
        start: new UntypedFormControl(null),
        end: new UntypedFormControl(null)
    });
    currentSetting: any;
    searchTextCtrl = new UntypedFormControl('');
    displayedColumns: string[] = ['LOGINTIME', 'LOGOUTTIME', 'USERNAME', 'NAME', 'REGION'];
    msg = new MsgModel();

    dataSource = new MatTableDataSource<LoginAudit>();
    lstLoginAudit: LoginAudit[] = [];
    constructor(public accountService: AccountService, private _liveAnnouncer: LiveAnnouncer,private dialog: MatDialog) {}

    ngOnInit(): void {
        this.searchTextCtrl.valueChanges.subscribe((x: string) => {
            let searchValue: string = x.toLowerCase();
            if (searchValue?.length > 0) {
                this.dataSource.data = this.lstLoginAudit.filter(
                    (searchData) =>
                        searchData.LOGIN_DETAILS.PERSON.FIRST_NAME?.toLowerCase().includes(searchValue) ||
                        searchData.LOGIN_DETAILS.PERSON.LAST_NAME?.toLowerCase().includes(searchValue) ||
                        searchData.LOGIN_DETAILS.USER_ID?.toLowerCase().includes(searchValue) ||
                        searchData.REGION.CODE?.toLowerCase().includes(searchValue) ||
                        new DatePipe('en-US').transform(searchData.LOGIN_TIME, 'MMM d, y, @ h:mm a')?.toLowerCase().includes(searchValue) ||
                        new DatePipe('en-US').transform(searchData.LOGIN_TIME, 'MMM d, y, @ h:mm a')?.toLowerCase().includes(searchValue)
                );
            } else {
                this.dataSource.data = this.lstLoginAudit;
            }
            this.paginatorEvent();
        });
    }
    ngAfterViewInit() {
        this.dataSource.paginator = this.searchPaginator;
    }
    resetSearchFields() {
        this.resetField = !this.resetField;
        this.range.reset();
        this.lstLoginAudit = [];
        this.dataSource = new MatTableDataSource<LoginAudit>();
        this.isLoadingResults = false;

        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        //Once ray emits reset for District need to implment.
    }
    
    search() {
        //this.reset();
        this.isLoadingResults = true;
        this.dataSource = new MatTableDataSource<LoginAudit>();

        const loginAuditRequest = {} as LoginAuditRequest;

        loginAuditRequest.fromDateString = this.start.value?.toDateString();
        loginAuditRequest.toDateString = this.end.value?.toDateString();
        loginAuditRequest.regions = this.lstSelectedRegion;

        this.accountService.getLoginAudits(loginAuditRequest).subscribe((lstLoginAudit: LoginAudit[]) => {
            this.lstLoginAudit = lstLoginAudit;
            this.dataSource.data = lstLoginAudit;
            this.paginatorEvent();
            this.isLoadingResults = false;
        });
    }

    validateSearchEnable() {
        if (this.lstSelectedRegion.length > 0 || (this.range.valid && this.range.dirty)) {
            return true;
        } else return false;
    }
    regionEventEmitter(lstRegion: Region[]) {
        this.lstSelectedRegion = lstRegion;
    }

    announceSortChange(sortState: Sort) {
        this.paginatorEvent();
    }

    paginatorEvent() {
        this.dataSource.paginator = this.searchPaginator;
        this.dataSource.sortingDataAccessor = sortingDataAccessor;
        this.dataSource.sort = this.sort;
    }

    get start(): any {
        return this.range.get('start');
    }
    get end(): any {
        return this.range.get('end');
    }
}
